import instance from '@/services/repository';

const resource = '/documents';

export default {
    lookup(query: FilesLookupQuery) {
        return instance
            .post(`${resource}/lookup`, query);
    },
    createDirectory(command: CreateFolderCommand) {
        return instance
            .post(`${resource}/createDirectory`, command);
    },
    uploadFileChunk(objectId: string, objectType: number, path: string, file: any, metaData: any) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', file);
        formDataToUpload.append('path', path);
        formDataToUpload.append('objectId', objectId);
        formDataToUpload.append('objectType', '' + objectType);

        formDataToUpload.append('metaData[index]', '' + metaData.index);
        formDataToUpload.append('metaData[totalCount]', '' + metaData.totalCount);
        formDataToUpload.append('metaData[fileSize]', '' + metaData.fileSize);
        formDataToUpload.append('metaData[fileName]', '' + metaData.fileName);
        formDataToUpload.append('metaData[fileType]', '' + metaData.fileType);
        formDataToUpload.append('metaData[fileGuid]', '' + metaData.fileGuid);
        return instance.post<IDocumentChunkUploadResult>(`${resource}/uploadChuncks`, formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    copyItem(command: CopyItemCommand) {
        return instance
            .post(`${resource}/copy`, command);
    },
    moveItem(command: MoveItemCommand) {
        return instance
            .post(`${resource}/move`, command);
    },
    renameItem(command: RenameItemCommand) {
        return instance
            .post(`${resource}/rename`, command);
    },
    deleteItem(key: string) {
        return instance
            .delete(`${resource}/remove/${key}`);
    },
    downloadItem(key: string) {
        return instance
            .get<Blob>(`${resource}/download/${key}`, { responseType: 'blob' });
    },
};
